
export function getTimeDate(dateString:string) {
    const date = new Date(dateString);
    return ("0" + (date.getHours())).slice(-2)+':'+("0" + (date.getMinutes())).slice(-2)+':'+("0" + (date.getSeconds())).slice(-2)+' '+("0" + (date.getDate())).slice(-2)+'.'+("0" + (date.getMonth()+1)).slice(-2)+'.'+date.getFullYear();
}



export function replaceEnterWithBr(text:string) {
    return text.replace(/\n/g, '<br/>');
}

export function replaceAndBoldText(text:string) {
    // Заменяем переносы строки на <br/>
    text = text.replace(/\n/g, '<br/>');
    // Заменяем *текст* на <b>текст</b>
    text = text.replace(/\*(.*?)\*/g, '<b>$1</b>');
    return text;
}


export function replaceBrWithEnter(text:string) {
    return text.replace(/<br\s*\/?>/g, '\n');
}

export function getRandomColor(name: string | undefined): string {
    const initial = name?.charAt(0).toUpperCase();
    const colors: string[] = [
        '#F44336', // red
        '#E91E63', // pink
        '#9C27B0', // purple
        '#673AB7', // deep purple
        '#3F51B5', // indigo
        '#2196F3', // blue
        '#03A9F4', // light blue
        '#00BCD4', // cyan
        '#009688', // teal
        '#4CAF50', // green
        '#8BC34A', // light green
        '#CDDC39', // lime
        '#FFEB3B', // yellow
        '#FFC107', // amber
        '#FF9800', // orange
        '#FF5722', // deep orange
        '#795548', // brown
        '#9E9E9E', // grey
        '#607D8B', // blue grey
    ];
    const index: number = initial ? initial.charCodeAt(0) % colors.length : 0;
    return colors[index];
}

interface OrderStatus {
    name: string;
    color: string;
    textColor: string;
}

// 1. Создаем Enum, который зеркально повторяет бэкенд (OrderStatus)
export enum OrderStatusEnum {
    WAITING_FUNDS = 1,
    PROCESSING = 2,
    PAID = 3,
    COMPLETED = 4,
    REJECTED = 5,
}

// 2. Enum для системных логов (зеркало SupportMessageType.ORDER_EDITED)
export enum SystemLogType {
    ORDER_EDITED = 10,
}

// 3. Интерфейс для UI-параметров статуса
export interface OrderStatusUI {
    name: string;
    color: string;
    textColor: string;
}

// 4. Сама функция с использованием Enum
export function getOrderStatus(num: OrderStatusEnum | number): OrderStatusUI {
    const orderStatuses: Record<number, OrderStatusUI> = {
        [OrderStatusEnum.WAITING_FUNDS]: { name: 'ожидание средств', color: 'rgba(151, 151, 151, 0.13)', textColor: "#8b8b8b" },
        [OrderStatusEnum.PROCESSING]: { name: 'обрабатывается', color: 'rgba(255, 115, 13, 0.13)', textColor: "#ff730d" },
        [OrderStatusEnum.PAID]: { name: 'оплачено', color: 'rgba(42, 185, 95, 0.13)', textColor: "#2ab95f" },
        [OrderStatusEnum.COMPLETED]: { name: 'выполнено', color: 'rgba(39, 125, 255, 0.13)', textColor: "#277dff" },
        [OrderStatusEnum.REJECTED]: { name: 'отменено', color: 'rgba(209, 0, 0, 0.13)', textColor: "#d10000" }
    };

    return orderStatuses[num] ? orderStatuses[num] : { name: 'error', color: '#808080', textColor: "#ffffff" };
}


const serverUrl = (process.env.REACT_APP_URL_SERVER || "").replace(/\/$/, "");

export const getFileUrl = (file?: string) => {
    if (!file) {
        return "";
    }

    if (/^https?:\/\//.test(file)) {
        return file;
    }

    return `${serverUrl}/${String(file).replace(/^\//, "")}`;
};

const isNameOptionalCode = (code: string) => {
    const normalizedCode = code.trim().toUpperCase();
    return normalizedCode === "USDT" || normalizedCode === "SWIFT USD";
};

export function getFileType(inputString: string) {
    // Ищем расширение файла с помощью регулярного выражения
    const match = inputString.match(/\.([a-zA-Z0-9]+)$/);
    if (match) {
        return match[1]; // Возвращаем расширение файла
    }
    return null; // Если не найдено, возвращаем null
}